/**
 * Round number to degree
 * @param value [number]
 * @param degree [number]
 */
export const round = (value: number, degree: number = 1) => {
  return Math.round(value * degree) / degree;
};
